export default "__VITE_ASSET__d2f00c8f__"